var map = {
	"./signal-0.png": 75704,
	"./signal-1.png": 96833,
	"./signal-2.png": 82602,
	"./signal-3.png": 21459,
	"./signal-4.png": 66588,
	"./signal-5.png": 49477
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36995;